// src/utils/deviceUtils.ts
// Utilities for device and environment detection

export const isMobileView = (maxWidth = 767): boolean => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(`(max-width: ${maxWidth}px)`).matches;
};

export const isTabletView = (minWidth = 768, maxWidth = 1024): boolean => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(`(min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`).matches;
};

export const isDesktopView = (minWidth = 1025): boolean => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(`(min-width: ${minWidth}px)`).matches;
};

export const isBrowser = (): boolean => {
  return typeof window !== 'undefined' && typeof window.document !== 'undefined';
};
